module.exports = __webpack_public_path__ + "img/a1.65c0005c.png";